export const isAllEqualInArray = (arr: unknown[]) =>
  arr.length > 0 && arr.every((v) => JSON.stringify(v) === JSON.stringify(arr.at(0)));
